import React, { useEffect, useState, useRef } from "react";
import axios from 'axios';
import { toast } from 'react-toastify';
import moment from 'moment';
import { Button, Form, Col, Row, Modal } from 'react-bootstrap';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import { DataTable } from 'primereact/datatable';
import { Paginator } from 'primereact/paginator';
import { Column } from 'primereact/column';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { InputText } from 'primereact/inputtext';
import { getNoticeImageUrl } from '../../Helpers';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/fluent-light/theme.css';

function Notice() {
  const [data, setData] = useState(false);
  const [pageData, setPageData] = useState(false);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const [noticeText, setNoticeText] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [previewModalImg, setPreviewModalImg] = useState(null);
  const fileInputRef = useRef(null);

  const header = (
    <div className="flex flex-wrap gap-2 align-items-center justify-content-between">
      <IconField iconPosition="right">
        <InputIcon className="pi pi-search" />
        <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Search..." />
      </IconField>
    </div>
  );

  const handleClose = () => {
    setShowModal(false);
    setNoticeText("");
    handleRemoveImage();
  };

  const handleFileChange = (e) => {
    const file = e.target.files && e.target.files[0];
    if (file) {
      if (!file.type.startsWith("image/")) {
        toast("Please select a valid image file (JPG, PNG, WEBP, GIF).");
        if (fileInputRef.current) fileInputRef.current.value = "";
        return;
      }
      if (file.size > 10 * 1024 * 1024) {
        toast("Image file size should be less than 10MB.");
        if (fileInputRef.current) fileInputRef.current.value = "";
        return;
      }
      setSelectedFile(file);
      const url = URL.createObjectURL(file);
      setImagePreview(url);
    }
  };

  const handleRemoveImage = () => {
    setSelectedFile(null);
    if (imagePreview) {
      URL.revokeObjectURL(imagePreview);
      setImagePreview(null);
    }
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const disableNotice = async (notice_id, request) => {
    try {
      const response = await axios.post('/admin/disable/notice', { notice_id, request });
      const { status, message } = response.data;
      if (status) {
        toast(message);
        setRefresh(!refresh);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!noticeText.trim() && !selectedFile) {
      toast("Please enter a notice message or upload an image.");
      return;
    }

    try {
      setSubmitting(true);
      const formData = new FormData();
      formData.append("message", noticeText.trim());
      if (selectedFile) {
        formData.append("image", selectedFile);
      }

      const response = await axios.post('/admin/add/notice', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      const { status, message } = response.data;
      if (status) {
        handleClose();
        setRefresh(!refresh);
        toast(message);
      } else {
        toast(message || "Failed to add notice.");
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      } else {
        toast("Failed to add notice.");
      }
    } finally {
      setSubmitting(false);
    }
  };

  const fetchData = async (event) => {
    let rechargeData = {
      first: event.first,
      rows: event.rows,
    };
    getData(rechargeData);
  };

  const getData = async (requestData = {}) => {
    try {
      setLoading(true);
      const response = await axios.post("/history/notice", requestData);
      const { status, first, rows, totalRecords } = response.data;
      if (status) {
        setData(response.data);
        setPageData({ first, rows, totalRecords });
        setLoading(false);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  useEffect(() => {
    getData();
  }, [refresh]);

  const ChangeStatus = async (options, e) => {
    options.editorCallback(e.target.value);
    try {
      const response = await axios.post('/admin/disable/notice', { notice_id: options.rowData._id, request: e.target.value });
      const { status, message } = response.data;
      if (status) {
        toast(message);
        setRefresh(!refresh);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  const onCellEditComplete = (e) => {
    let { rowData, newValue, field, originalEvent: event } = e;
    if (newValue && newValue.trim().length > 0) rowData[field] = newValue;
    else event.preventDefault();
  };

  const cellEditor = (options) => {
    return (
      <select value={options.value} onChange={(e) => ChangeStatus(options, e)} onKeyDown={(e) => e.stopPropagation()}>
        <option value="active">active</option>
        <option value="disabled">disabled</option>
      </select>
    );
  };

  return (
    <div className="content-wrapper">
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">
                Notices
                {/* Button that triggers the modal */}
                <Button className="float-right" variant="primary" onClick={() => setShowModal(true)}>
                  Add
                </Button>
              </h4>
            </div>
          </div>
        </div>
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              {data && (
                <>
                  <h4 className="card-title">
                    Notices
                  </h4>
                  <DataTable
                    value={data.data}
                    size="small"
                    editMode="cell"
                    globalFilter={globalFilter}
                    header={header}
                    className="custom-table"
                    loading={loading}
                  >
                    <Column
                      field="index"
                      header="#"
                      sortable
                      body={(rowData, { rowIndex }) => <span data-label="#">{pageData?.first + rowIndex + 1}</span>}
                    />
                    <Column
                      field="created_at"
                      header="Date"
                      sortable
                      body={(rowData) => (
                        <span data-label="Date">
                          {moment(rowData.created_at).format('MMM-DD-YYYY')}
                          <br />
                          {moment(rowData.created_at).format('hh:mm:ss A')}
                        </span>
                      )}
                    />
                    <Column
                      field="image"
                      header="Image"
                      body={(rowData) => {
                        const imgUrl = getNoticeImageUrl(rowData?.image);
                        return imgUrl ? (
                          <span data-label="Image">
                            <img
                              src={imgUrl}
                              alt="Notice"
                              style={{
                                width: '56px',
                                height: '56px',
                                objectFit: 'cover',
                                borderRadius: '8px',
                                cursor: 'pointer',
                                border: '1px solid #e2e8f0',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.06)',
                              }}
                              onClick={() => setPreviewModalImg(imgUrl)}
                              title="Click to preview full image"
                            />
                          </span>
                        ) : (
                          <span data-label="Image" className="text-muted small">No Image</span>
                        );
                      }}
                    />
                    <Column
                      field="message"
                      header="Message"
                      sortable
                      body={(rowData) => (
                        <span data-label="Message">
                          {rowData?.message ? (
                            <span style={{ whiteSpace: 'pre-wrap' }}>{rowData.message}</span>
                          ) : (
                            <span className="text-muted font-italic">(Image only)</span>
                          )}
                        </span>
                      )}
                    />
                    <Column
                      field="status"
                      header="Status"
                      sortable
                      body={(rowData) => <span data-label="Status">{rowData?.status}</span>}
                      editor={(options) => cellEditor(options)}
                      onCellEditComplete={onCellEditComplete}
                    />
                    <Column
                      field="action"
                      header="Action"
                      sortable
                      body={(rowData) => (
                        <span data-label="Action">
                          <button className="btn btn-primary" onClick={() => disableNotice(rowData?._id, "delete")}>
                            Delete
                          </button>
                        </span>
                      )}
                    />
                  </DataTable>
                  <div className="card">
                    <Paginator
                      first={pageData && pageData.first}
                      rows={pageData && pageData.rows}
                      totalRecords={pageData && pageData.totalRecords}
                      rowsPerPageOptions={[5, 10, 20, 30, 40, 50, 100, 200, 300, 400, 500, 1000]}
                      onPageChange={fetchData}
                    />
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Add Notice Modal */}
      <Modal show={showModal} onHide={handleClose} centered size={'lg'} backdrop="static">
        <Form onSubmit={handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Add Notice</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-12 mb-3">
                <Form.Group>
                  <Form.Label className="font-weight-bold">
                    Notice Message <span className="text-muted font-weight-normal">(Optional if image uploaded)</span>
                  </Form.Label>
                  <textarea
                    className="form-control"
                    name="noticeMessage"
                    rows="4"
                    placeholder="Enter notice announcement text..."
                    value={noticeText}
                    onChange={(e) => setNoticeText(e.target.value)}
                  ></textarea>
                </Form.Group>
              </div>

              <div className="col-12 mb-2">
                <Form.Group>
                  <Form.Label className="font-weight-bold">
                    Notice Image <span className="text-muted font-weight-normal">(Optional if message entered)</span>
                  </Form.Label>
                  <div
                    className="border rounded p-3 bg-light text-center"
                    style={{ borderStyle: 'dashed !important', borderWidth: '2px' }}
                  >
                    <input
                      type="file"
                      id="noticeImageInput"
                      ref={fileInputRef}
                      className="d-none"
                      accept="image/png, image/jpeg, image/jpg, image/webp, image/gif"
                      onChange={handleFileChange}
                    />
                    {!imagePreview ? (
                      <div className="py-2">
                        <div className="mb-2">
                          <i className="ti-cloud-up" style={{ fontSize: '38px', color: '#4f46e5' }}></i>
                        </div>
                        <p className="mb-1 text-dark font-weight-semibold">Click to upload image for this notice</p>
                        <p className="text-muted small mb-2">Supports JPG, PNG, WEBP, GIF (Max 10MB)</p>
                        <Button
                          type="button"
                          variant="outline-primary"
                          size="sm"
                          onClick={() => fileInputRef.current && fileInputRef.current.click()}
                        >
                          <i className="ti-upload me-1"></i> Choose Image
                        </Button>
                      </div>
                    ) : (
                      <div>
                        <div className="d-flex justify-content-between align-items-center mb-2 px-1">
                          <span className="text-muted small text-truncate" style={{ maxWidth: '75%' }}>
                            <i className="ti-image me-1 text-primary"></i>
                            <strong>{selectedFile?.name}</strong> ({((selectedFile?.size || 0) / 1024).toFixed(1)} KB)
                          </span>
                          <Button
                            type="button"
                            variant="outline-danger"
                            size="sm"
                            onClick={handleRemoveImage}
                          >
                            <i className="ti-trash me-1"></i> Remove Image
                          </Button>
                        </div>
                        <div className="p-2 bg-white rounded border d-flex justify-content-center align-items-center">
                          <img
                            src={imagePreview}
                            alt="Selected Notice Preview"
                            style={{ maxHeight: '220px', maxWidth: '100%', objectFit: 'contain', borderRadius: '8px' }}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </Form.Group>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button type="button" variant="secondary" onClick={handleClose} disabled={submitting}>
              Cancel
            </Button>
            <Button type="submit" variant="primary" disabled={submitting}>
              {submitting ? (
                <>
                  <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                  Adding...
                </>
              ) : (
                "Add Notice"
              )}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      {/* Lightbox / Preview Modal for Table Row Image */}
      <Modal show={!!previewModalImg} onHide={() => setPreviewModalImg(null)} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Notice Image Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center p-3 bg-light">
          {previewModalImg && (
            <img
              src={previewModalImg}
              alt="Notice full preview"
              style={{ maxWidth: '100%', maxHeight: '550px', objectFit: 'contain', borderRadius: '8px' }}
            />
          )}
        </Modal.Body>
        <Modal.Footer>
          <a
            href={previewModalImg}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-outline-primary btn-sm me-auto"
          >
            <i className="ti-new-window me-1"></i> Open in New Tab
          </a>
          <Button variant="secondary" size="sm" onClick={() => setPreviewModalImg(null)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default Notice;
